import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="innovativeimg">
                                            <img alt=""
                                                 src={require('@images/How to identify personal learning styles.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">isn't it interesting?</span>
                                            </div>
                                            <p>Do as I say, not as I do.....?</p>


                                            <div className="border_subtitle">Learning through imitation</div>
                                            <p>One way we learn is through imitation. When we watch other people
                                                role modelling behaviour, we
                                                learn how to do things and also recognise what is and isn’t
                                                acceptable behaviour. This can be
                                                particularly seen in children as they develop; many parents will
                                                have examples of situations where
                                                their children have picked up both desirable and undesirable
                                                habits by imitating them. However,
                                                this is not just a childhood phenomenon but a way of learning
                                                that we use throughout our lifetime.</p>


                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">How do you learn best?</div>
                                                <div className="paraspace">
                                                    <p>In 1983, Dr. Howard Gardner<a
                                                        className="superscripttext supLinesapce"
                                                        href="further_info.php?course=300"><sup>1</sup></a> developed
                                                        the theory of multiple intelligences. This suggests
                                                        that there are different types of intelligence and our
                                                        learning style will depend on the type
                                                        of intelligence we have. Likewise, knowledge of these
                                                        intelligence types will help us to
                                                        understand how we can begin to identify the learning
                                                        styles of those around us.</p></div>
                                                <div className="paraspace"><p>The different types of
                                                    intelligence identified were:</p></div>
                                                <ul className="greenbullet-list sept">
                                                    <li>Linguistic intelligence (words)</li>
                                                    <li>Logical–mathematical intelligence (numbers or logic)
                                                    </li>
                                                    <li>Spatial intelligence (pictures)</li>
                                                    <li>Musical intelligence (music)</li>
                                                    <li>Body-kinesthetic intelligence (physical experience)</li>
                                                    <li>Interpersonal intelligence (social experience).</li>
                                                </ul>
                                                <div className="uiheading"><p>So when you have had difficulty
                                                    grasping or understanding a topic, consider the
                                                    different ways in which the messages can be communicated to
                                                    tap into your preferred
                                                    learning method.</p></div>
                                            </div>


                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}